// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    Nfc,
    NonBinary,
    Notebook,
    NotebookPen,
    NotebookTabs,
    NotebookText,
    NotepadText,
    NotepadTextDashed,
    Nut,
    NutOff,
    Octagon,
    OctagonAlert,
    OctagonMinus,
    OctagonPause,
    OctagonX,
    Omega,
    Option,
    Orbit,
    Origami,
    Package,
    Package2,
    PackageCheck,
    PackageMinus,
    PackageOpen,
    PackagePlus,
    PackageSearch,
    PackageX,
    PaintBucket,
    PaintRoller,
    Paintbrush,
    PaintbrushVertical,
    Palette,
    Panda,
    PanelBottom,
    PanelBottomClose,
    PanelBottomDashed,
    PanelBottomOpen,
    PanelLeft,
    PanelLeftClose,
    PanelLeftDashed,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "nfc" through "panel-left-dashed", inclusive. */
const shard: Record<string, LucideIcon> = {
    nfc: Nfc,
    "non-binary": NonBinary,
    notebook: Notebook,
    "notebook-pen": NotebookPen,
    "notebook-tabs": NotebookTabs,
    "notebook-text": NotebookText,
    "notepad-text": NotepadText,
    "notepad-text-dashed": NotepadTextDashed,
    nut: Nut,
    "nut-off": NutOff,
    octagon: Octagon,
    "octagon-alert": OctagonAlert,
    "octagon-minus": OctagonMinus,
    "octagon-pause": OctagonPause,
    "octagon-x": OctagonX,
    omega: Omega,
    option: Option,
    orbit: Orbit,
    origami: Origami,
    package: Package,
    "package-2": Package2,
    "package-check": PackageCheck,
    "package-minus": PackageMinus,
    "package-open": PackageOpen,
    "package-plus": PackagePlus,
    "package-search": PackageSearch,
    "package-x": PackageX,
    "paint-bucket": PaintBucket,
    "paint-roller": PaintRoller,
    paintbrush: Paintbrush,
    "paintbrush-vertical": PaintbrushVertical,
    palette: Palette,
    panda: Panda,
    "panel-bottom": PanelBottom,
    "panel-bottom-close": PanelBottomClose,
    "panel-bottom-dashed": PanelBottomDashed,
    "panel-bottom-open": PanelBottomOpen,
    "panel-left": PanelLeft,
    "panel-left-close": PanelLeftClose,
    "panel-left-dashed": PanelLeftDashed,
};

export default shard;
